import { companySignInDTOSchema, microsoftConsentStartDTOSchema, signInDiscoveryDTOSchema, tenantCompanySignInAdminDTOSchema, } from '@instanexus/contracts';
import { z } from 'zod';
import { dataEnvelopeSchema, WEB_API_PREFIX } from '../transport.js';
const TENANT_SSO = `${WEB_API_PREFIX}/tenant/sso`;
const OPERATOR_SSO = `${WEB_API_PREFIX}/sso/tenants`;
const DISCOVER = `${WEB_API_PREFIX}/auth/sso/discover`;
export function createSsoResource(transport) {
    return {
        async get() {
            const res = await transport.request({
                method: 'GET',
                path: TENANT_SSO,
                schema: dataEnvelopeSchema(companySignInDTOSchema),
            });
            return res.data;
        },
        async verifyDomain(input) {
            const res = await transport.request({
                method: 'POST',
                path: `${TENANT_SSO}/domains/verify`,
                body: input,
                schema: dataEnvelopeSchema(companySignInDTOSchema),
            });
            return res.data;
        },
        async enableEnforcement(input) {
            const res = await transport.request({
                method: 'POST',
                path: `${TENANT_SSO}/enforcement`,
                body: input,
                schema: dataEnvelopeSchema(companySignInDTOSchema),
            });
            return res.data;
        },
        async disableEnforcement() {
            const res = await transport.request({
                method: 'DELETE',
                path: `${TENANT_SSO}/enforcement`,
                schema: dataEnvelopeSchema(companySignInDTOSchema),
            });
            return res.data;
        },
        async remove() {
            await transport.request({ method: 'DELETE', path: TENANT_SSO, schema: z.undefined() });
        },
        async discover(input) {
            const res = await transport.request({
                method: 'POST',
                path: DISCOVER,
                body: input,
                schema: dataEnvelopeSchema(signInDiscoveryDTOSchema),
            });
            return res.data;
        },
        async getForTenant(tenantId) {
            const res = await transport.request({
                method: 'GET',
                path: `${OPERATOR_SSO}/${encodeURIComponent(tenantId)}`,
                schema: dataEnvelopeSchema(tenantCompanySignInAdminDTOSchema),
            });
            return res.data;
        },
        async suspendEnforcement(tenantId, input) {
            const res = await transport.request({
                method: 'POST',
                path: `${OPERATOR_SSO}/${encodeURIComponent(tenantId)}/enforcement-suspension`,
                body: input,
                schema: dataEnvelopeSchema(tenantCompanySignInAdminDTOSchema),
            });
            return res.data;
        },
        async resumeEnforcement(tenantId, input) {
            const res = await transport.request({
                method: 'POST',
                path: `${OPERATOR_SSO}/${encodeURIComponent(tenantId)}/enforcement-suspension/end`,
                body: input,
                schema: dataEnvelopeSchema(tenantCompanySignInAdminDTOSchema),
            });
            return res.data;
        },
        async startMicrosoftConsent() {
            const res = await transport.request({
                method: 'POST',
                path: `${TENANT_SSO}/microsoft/consent/start`,
                schema: dataEnvelopeSchema(microsoftConsentStartDTOSchema),
            });
            return res.data;
        },
        async completeMicrosoftConsent(input) {
            const res = await transport.request({
                method: 'POST',
                path: `${TENANT_SSO}/microsoft/consent/complete`,
                body: input,
                schema: dataEnvelopeSchema(companySignInDTOSchema),
            });
            return res.data;
        },
        async addEnterpriseDomain(input) {
            const res = await transport.request({
                method: 'POST',
                path: `${TENANT_SSO}/enterprise/domains`,
                body: input,
                schema: dataEnvelopeSchema(companySignInDTOSchema),
            });
            return res.data;
        },
        async configureEnterpriseIdentityProvider(input) {
            const res = await transport.request({
                method: 'PUT',
                path: `${TENANT_SSO}/enterprise/identity-provider`,
                body: input,
                schema: dataEnvelopeSchema(companySignInDTOSchema),
            });
            return res.data;
        },
        async enableEmailFallback(tenantId, input) {
            const res = await transport.request({
                method: 'POST',
                path: `${OPERATOR_SSO}/${encodeURIComponent(tenantId)}/email-fallback`,
                body: input,
                schema: dataEnvelopeSchema(tenantCompanySignInAdminDTOSchema),
            });
            return res.data;
        },
        async endEmailFallback(tenantId, input) {
            const res = await transport.request({
                method: 'POST',
                path: `${OPERATOR_SSO}/${encodeURIComponent(tenantId)}/email-fallback/end`,
                body: input,
                schema: dataEnvelopeSchema(tenantCompanySignInAdminDTOSchema),
            });
            return res.data;
        },
        async sendDomainEmailCode(input) {
            await transport.request({
                method: 'POST',
                path: `${TENANT_SSO}/domains/email-code`,
                body: input,
                schema: z.undefined(),
            });
        },
        async verifyDomainEmailCode(input) {
            const res = await transport.request({
                method: 'POST',
                path: `${TENANT_SSO}/domains/email-code/verify`,
                body: input,
                schema: dataEnvelopeSchema(companySignInDTOSchema),
            });
            return res.data;
        },
        async setJitProvisioning(input) {
            const res = await transport.request({
                method: 'PUT',
                path: `${TENANT_SSO}/jit-provisioning`,
                body: input,
                schema: dataEnvelopeSchema(companySignInDTOSchema),
            });
            return res.data;
        },
    };
}
//# sourceMappingURL=sso.js.map